import type { WalkthroughStep } from "../types";

/**
 * The Coordinates Helper's tour, which only ever runs because somebody asked.
 *
 * This tool has no sample pack: it opens with a `vector3(...)` already pasted
 * and has its own "Try" examples, so there is no `welcome` step. The one way in
 * is the permanent "Show me how this works" control beside the input
 * (`ShowTourButton`), and the island mounts `ToolWalkthrough` in manual mode, so
 * nothing here is ever thrown over coordinates somebody is in the middle of
 * converting.
 *
 * The results list only exists once at least three numbers parse. A step whose
 * anchor is missing degrades to a centred tooltip, so the body reads as an
 * explanation of that part of the page rather than "look at this row".
 *
 * These steps RESTATE what the page already says; the placeholder and the
 * "at least three numbers" hint stay in the interface.
 */
export const steps: WalkthroughStep[] = [
  {
    id: "input",
    title: "Paste coordinates in any shape",
    body: "A `vector3(...)` call, `X: Y: Z:` from a debug overlay, or just numbers separated by commas or spaces. The first three numbers are x, y and z; a fourth is read as the heading.",
    selector: "[data-walkthrough='crd-input']",
    placement: "bottom",
  },
  {
    id: "examples",
    title: "Or try an example",
    body: "Each fills the box with one of the shapes above, so you can see how the same position comes out in every format.",
    selector: "[data-walkthrough='crd-examples']",
    placement: "bottom",
  },
  {
    id: "decimals",
    title: "How many decimals",
    body: "Rounds every output to between 0 and 6 decimal places, and trailing zeros are trimmed. Raise it when a position has to be exact.",
    selector: "[data-walkthrough='crd-decimals']",
    placement: "bottom",
  },
  {
    id: "results",
    title: "Every format at once",
    body: "Lua vector3 and vec3, vector4, C# Vector3, a Lua table, a JS object, an array and plain CSV. Copy the row you need with its button. The vector4 row uses a heading of 0 unless you pasted a fourth number.",
    selector: "[data-walkthrough='crd-results']",
    placement: "top",
  },
];

export const finishLabel = "Start converting";
